import { Router } from '@angular/router';
import { AppConstant } from 'src/app/_Core/_Constants/app.constant';
import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Locale } from 'src/app/_Core/_Constants/locale.constant';
import { CommonService } from '../_Services/common.service';

@Injectable()
export class HttpInterceptorProvider implements HttpInterceptor {
  isOnline: boolean = true;
  constructor(private appStateSrv: AppStateProvider, private router: Router, private commonService:CommonService
  ) {
    this.appStateSrv.checkOnlineStatus().subscribe(isOnline => {
      if (this.isOnline == false && isOnline == true) {
        this.appStateSrv.showToast(Locale.INFO.ONLINE);
        setTimeout(() => {
          window.location.reload();
        }, 1000)
      }
      this.isOnline = isOnline;
      if (!isOnline)
        this.appStateSrv.showToast(Locale.ERROR.OFFLINE);
    });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (!this.isOnline) {
      this.appStateSrv.showToast(Locale.ERROR.OFFLINE);
      return throwError(() => 'You are currently offline.');
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        //this.closeLoader();
        if (event instanceof HttpResponse) {
          if (event.body && event.body.errorMsg !== null && event.body.errorMsg !== '' && !request.url.includes('GetNotificationDetails') && !this.router.url.includes('verifyemail'))
            this.appStateSrv.showToast(event.body.errorMsg);
          if (event.body && event.body.successMsg !== null && event.body.successMsg !== '' && !request.url.includes('GetNotificationDetails') && !this.router.url.includes('verifyemail'))
            this.appStateSrv.showToast(event.body.successMsg);
        }

        // if(event.type === 0){
        return event;
        //}
      }),
      catchError((error: HttpErrorResponse, header) => {
        switch (error.status) {
          case 400:
            console.log(error.error.errors);
            if(this.ObjectSize(error.error.errors) > 0) {
              // error.error.errors.forEach(element => {
              //   this.appStateSrv.showToast(element);
              // });
              for (let [key, value] of Object.entries(error.error.errors)) {
                console.log(key, value);
                error.error.errors[key].forEach(element => {
                  this.appStateSrv.showToast(element);
                });
              }
            } else {
              this.appStateSrv.showToast(Locale.ERROR[400]);
            }
            break;
          case 401:
            this.appStateSrv.showToast(Locale.ERROR[401]);
            this.commonService.logoutToken().subscribe(res => {
              localStorage.clear()
              this.router.navigateByUrl("");
              window.location.reload();
            });
            // localStorage.clear()
            // if (this.adalService.isAuthenticated == true) {
            //   this.adalService.logout();
            // }
            break;
          case 403:
            this.appStateSrv.showToast(Locale.ERROR[403]);
            break;
          case 409:
            this.appStateSrv.showToast(Locale.ERROR[409]);
            break;
          case 400:
            this.appStateSrv.showToast(Locale.ERROR[400]);
            break
          case 404:
            this.appStateSrv.showToast(Locale.ERROR[404]);
            break
          case 500:
            this.appStateSrv.showToast(Locale.ERROR[500]);
            break;
          case 413:
            this.appStateSrv.showToast(Locale.ERROR[413]);
            break;
          case 0:
            this.appStateSrv.showToast(Locale.ERROR.NETWORK_FAILURE)
            break;
          default: this.appStateSrv.showToast(Locale.ERROR.NETWORK_FAILURE)
        }
        return throwError(() => error.message);
      })
    );
  }

  ObjectSize(obj) {
    var size = 0,
      key;
    for (key in obj) {
      if (obj.hasOwnProperty(key)) size++;
    }
    return size;
  };
}
